import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import * as mutationTypes from './mutation-types';

export interface State {
  OneRadio: any;
  TwoRadio: any;
  ThreeRadio: any;
  index: number;
  Radios: any[];
}
const state: State = {
  OneRadio: '',
  TwoRadio: '',
  ThreeRadio: '',
  index: 0,
  Radios: [],
};

const mutations: MutationTree<State> = {
  [mutationTypes.CHANGE_VOTE_INDEX](state, index) {
    state.index = index;
    console.log('state.voteRadio', state.index);
  },
  [mutationTypes.GET_VOTE_RADIO](state, params) {
    // state.OneRadio = params;
    // state.Radios.push(state.OneRadio);
    // if (state.index == 1) {
    //   state.OneRadio = params;
    //   state.Radios.push(state.OneRadio);
    // } else if (state.index == 2) {
    //   state.TwoRadio = params;
    //   console.log('state.TwoRadio', state.TwoRadio);
    // }
    // console.log('state.Radios', state.Radios);
  },
};

const XHZW2019: Module<State, any> = {
  namespaced: true,
  state,
  mutations,
  // actions,
};

export default XHZW2019;
